
import { httpRequest } from "../../http";

export class CommandGetObjective {
    //TODO ADD PARAMS
    async run( engagementId: number) {  
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/objectives/`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            //TODO ADD SERIALIZER
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    // deserialize(data: any) : EngagementTeam []{
    //     const serializer = new EngagementTeamSerializer();
    //     return serializer.deserializeList(data);
    // }
}

